(function () {
// @ts-nocheck
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.scoreMax = 0;
        this.board = initialState ? (0, $227c6742e0ff6f82$export$71511d61b312f219)(this._getBlankBoard()) : initialState;
        this.scoreCurrent = 0;
        this.gameStatus = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            /**
   * Generate blank board
   * @returns blank board array
   */ key: "_getBlankBoard",
            value: function _getBlankBoard() {
                return Array.from({
                    length: 4
                }, function() {
                    return Array.from({
                        length: 4
                    }, function() {
                        return 0;
                    });
                });
            }
        },
        {
            /**
   * Innitiate game
   */ key: "_initialize",
            value: function _initialize() {
                this.board = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this._getBlankBoard());
                this._genRandCells();
                this._genRandCells();
            }
        },
        {
            key: "_clearBoard",
            value: function _clearBoard() {
                this.board = this._getBlankBoard();
            }
        },
        {
            /**
   * Generate 2 random tiles and populates the board
   * @returns {undefined}
   */ key: "_genRandCells",
            value: function _genRandCells() {
                var randTile = this._generateRandomTile(this.board);
                if (!randTile) return;
                this.board[randTile[0]][randTile[1]] = randTile[2];
            }
        },
        {
            /**
   * Function generate random row and colum which is currently unpopulated
   * Also return random number 2 or 4 with 4 (10% probability)
   * @param {number[][]} boardArrs
   * @returns [random row, random colum, random number]
   */ key: "_generateRandomTile",
            value: function _generateRandomTile(boardArrs) {
                var randRow;
                var randCol;
                do {
                    randRow = Math.floor(Math.random() * boardArrs.length);
                    randCol = Math.floor(Math.random() * boardArrs[0].length);
                }while (boardArrs[randRow][randCol] !== 0);
                var randValue = 2;
                if (Math.floor(Math.random() * 100 + 1) <= 10) randValue = 4;
                return [
                    randRow,
                    randCol,
                    randValue
                ];
            }
        },
        {
            /**
   * Check if can continue to play
   * @returns true or false
   * true- can continue the game
   * false - stop the game (no moves, win or lose)
   */ key: "_checkGameStatus",
            value: function _checkGameStatus() {
                if (this.board.some(function(row) {
                    return row.some(function(cell) {
                        return cell === 2048;
                    });
                })) {
                    this.gameStatus = "win";
                    return false;
                }
                var freeTiles = this.board.reduce(function(acc, cur) {
                    return acc + cur.filter(function(cell) {
                        return cell === 0;
                    }).length;
                }, 0);
                if (this._anyMovesLeft() === false && freeTiles === 0) {
                    this.gameStatus = "lose";
                    return false;
                }
                this.gameStatus = "playing";
                return true;
            }
        },
        {
            key: "_didTileMoved",
            value: function _didTileMoved(newArr, oldArr) {
                for(var row = 0; row < oldArr.length; row++)for(var col = 0; col < oldArr[row].length; col++){
                    if (oldArr[row][col] !== newArr[row][col]) return true;
                }
                return false;
            }
        },
        {
            key: "_anyMovesLeft",
            value: function _anyMovesLeft() {
                var posMoves = [
                    this._combineTiles("ArrowLeft", this.board)["score"],
                    this._combineTiles("ArrowRight", this.board)["score"],
                    this._combineTiles("ArrowUp", this.board)["score"],
                    this._combineTiles("ArrowDown", this.board)["score"]
                ];
                return posMoves.some(function(m) {
                    return m !== 0;
                });
            }
        },
        {
            key: "moves",
            value: function moves(direction) {
                if (this.getStatus() === "playing") {
                    var beforeMoveBoard = this._arrayDeepCopy(this.board);
                    var combBoard = this._combineTiles(direction, this.board);
                    this.board = this._arrayDeepCopy(combBoard["board"]);
                    this.scoreCurrent += combBoard["score"];
                    this._updateMaxScore(this.scoreCurrent);
                    if (this._didTileMoved(beforeMoveBoard, this.board)) this._genRandCells();
                    this._checkGameStatus();
                }
            }
        },
        {
            key: "_shiftRight",
            value: function _shiftRight(arrN) {
                var arr = (0, $227c6742e0ff6f82$export$71511d61b312f219)(arrN);
                for(var r = 0; r < arr.length; r++){
                    var temp = arr[r].filter(function(e) {
                        return e;
                    });
                    arr[r] = Array.from({
                        length: arr[r].length - temp.length
                    }, function() {
                        return 0;
                    }).concat(temp);
                }
                return arr;
            }
        },
        {
            key: "_shiftLeft",
            value: function _shiftLeft(arrN) {
                var arr = (0, $227c6742e0ff6f82$export$71511d61b312f219)(arrN);
                for(var r = 0; r < arr.length; r++){
                    var temp = arr[r].filter(function(e) {
                        return e;
                    });
                    arr[r] = temp.concat(Array.from({
                        length: arr[r].length - temp.length
                    }, function() {
                        return 0;
                    }));
                }
                return arr;
            }
        },
        {
            key: "_transpose",
            value: function _transpose(arr) {
                var temp = [];
                for(var cols = 0; cols < arr.length; cols++){
                    var tempCol = [];
                    for(var rows = 0; rows < arr[0].length; rows++)tempCol.push(arr[rows][cols]);
                    temp.push(tempCol);
                }
                return temp;
            }
        },
        {
            key: "_combineTiles",
            value: function _combineTiles(direction, board) {
                function combLeft() {
                    for(var row = 0; row < tempBoard.length; row++)for(var col = 0; col < tempBoard[row].length - 1; col++){
                        var el = tempBoard[row][col];
                        var elRight = tempBoard[row][col + 1];
                        if (el && elRight && el === elRight) {
                            tempBoard[row][col] = el + elRight;
                            tempBoard[row][col + 1] = 0;
                            col++;
                            tempScore = el + elRight;
                        }
                    }
                }
                function combRight() {
                    for(var row = tempBoard.length - 1; row >= 0; row--)for(var col = tempBoard[row].length - 1; col >= 1; col--){
                        var el = tempBoard[row][col];
                        var elLeft = tempBoard[row][col - 1];
                        if (el && elLeft && el === elLeft) {
                            tempBoard[row][col] = el + elLeft;
                            tempBoard[row][col - 1] = 0;
                            col--;
                            tempScore = el + elLeft;
                        }
                    }
                }
                var tempBoard = this._arrayDeepCopy(board);
                var tempScore = 0;
                switch(direction){
                    case "ArrowLeft":
                        tempBoard = this._shiftLeft(tempBoard);
                        combLeft();
                        tempBoard = this._shiftLeft(tempBoard);
                        break;
                    case "ArrowRight":
                        tempBoard = this._shiftRight(tempBoard);
                        combRight();
                        tempBoard = this._shiftRight(tempBoard);
                        break;
                    case "ArrowUp":
                        tempBoard = this._transpose(tempBoard);
                        tempBoard = this._shiftLeft(tempBoard);
                        combLeft();
                        tempBoard = this._shiftLeft(tempBoard);
                        tempBoard = this._transpose(tempBoard);
                        break;
                    case "ArrowDown":
                        tempBoard = this._transpose(tempBoard);
                        tempBoard = this._shiftRight(tempBoard);
                        combLeft();
                        tempBoard = this._shiftRight(tempBoard);
                        tempBoard = this._transpose(tempBoard);
                        break;
                }
                return {
                    board: tempBoard,
                    score: tempScore
                };
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.scoreCurrent;
            }
        },
        {
            key: "getScoreMax",
            value: function getScoreMax() {
                return this.scoreMax;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.gameStatus;
            }
        },
        {
            key: "getBoard",
            value: function getBoard() {
                return this.board;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.gameStatus = "playing";
                this._initialize();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.scoreCurrent = 0;
                this.gameStatus = "idle";
                this._clearBoard();
            }
        },
        {
            key: "_arrayDeepCopy",
            value: function _arrayDeepCopy(obj) {
                var _this = this;
                if (typeof obj !== "object" || obj === null) return obj;
                if (obj instanceof Date) return new Date(obj.getTime());
                if (obj instanceof Array) return obj.reduce(function(arr, item, i) {
                    arr[i] = _this._arrayDeepCopy(item);
                    return arr;
                }, []);
                if (obj instanceof Object) return Object.keys(obj).reduce(function(newObj, key) {
                    newObj[key] = _this._arrayDeepCopy(obj[key]);
                    return newObj;
                }, {});
            }
        },
        {
            key: "_updateMaxScore",
            value: function _updateMaxScore(curScore) {
                if (this.scoreMax < curScore) this.scoreMax = curScore;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$boardEl = document.querySelector(".game-field > tbody");
var $197cd56b15c33885$var$startBt = document.querySelector(".start");
var $197cd56b15c33885$var$scoreCur = document.querySelector(".curScore");
var $197cd56b15c33885$var$scoreMax = document.querySelector(".maxScore");
var $197cd56b15c33885$var$msgStartEl = document.querySelector(".message-start");
var $197cd56b15c33885$var$msgWinEl = document.querySelector(".message-win");
var $197cd56b15c33885$var$msgLoseEl = document.querySelector(".message-lose");
var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
function $197cd56b15c33885$var$update() {
    var curBoard = $197cd56b15c33885$var$game.getBoard();
    for(var row = 0; row < curBoard.length; row++)for(var i = 0; i < curBoard[row].length; i++){
        var cel = $197cd56b15c33885$var$boardEl.rows[row].cells[i];
        var val = curBoard[row][i];
        if (val) {
            cel.textContent = val;
            cel.classList = "field-cell";
            cel.classList.add("field-cell--".concat(val));
        } else {
            cel.textContent = "";
            cel.classList = "field-cell";
        }
    }
    $197cd56b15c33885$var$scoreMax.textContent = String($197cd56b15c33885$var$game.getScoreMax());
    $197cd56b15c33885$var$scoreCur.textContent = String($197cd56b15c33885$var$game.getScore());
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$startBt.className = "button start";
        $197cd56b15c33885$var$startBt.textContent = "Start";
    } else {
        $197cd56b15c33885$var$startBt.className = "button restart";
        $197cd56b15c33885$var$startBt.textContent = "Restart";
    }
    switch($197cd56b15c33885$var$game.getStatus()){
        case "playing":
            [
                $197cd56b15c33885$var$msgStartEl,
                $197cd56b15c33885$var$msgWinEl,
                $197cd56b15c33885$var$msgLoseEl
            ].forEach(function(msg) {
                return !(msg === null || msg === void 0 ? void 0 : msg.classList.contains("hidden")) ? msg === null || msg === void 0 ? void 0 : msg.classList.add("hidden") : "";
            });
            break;
        case "idle":
            $197cd56b15c33885$var$msgStartEl === null || $197cd56b15c33885$var$msgStartEl === void 0 ? void 0 : $197cd56b15c33885$var$msgStartEl.classList.remove("hidden");
            break;
        case "win":
            $197cd56b15c33885$var$msgWinEl === null || $197cd56b15c33885$var$msgWinEl === void 0 ? void 0 : $197cd56b15c33885$var$msgWinEl.classList.remove("hidden");
            break;
        case "lose":
            $197cd56b15c33885$var$msgLoseEl === null || $197cd56b15c33885$var$msgLoseEl === void 0 ? void 0 : $197cd56b15c33885$var$msgLoseEl.classList.remove("hidden");
            break;
    }
}
document.addEventListener("keydown", function(ev) {
    if ($197cd56b15c33885$var$game.getStatus() === "playing") $197cd56b15c33885$var$game.moves(ev.key);
    $197cd56b15c33885$var$update();
});
$197cd56b15c33885$var$startBt === null || $197cd56b15c33885$var$startBt === void 0 ? void 0 : $197cd56b15c33885$var$startBt.addEventListener("click", function(ev) {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$update();
});

})();
//# sourceMappingURL=index.d48e8a26.js.map
